import type { ChangeEvent, TextareaHTMLAttributes } from 'react'

type Base = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange' | 'value'>

export function TextArea({
  value,
  onChange,
  onChangeEvent,
  className,
  ...rest
}: {
  readonly value: string
  readonly onChange?: (value: string) => void
  readonly onChangeEvent?: (event: ChangeEvent<HTMLTextAreaElement>) => void
} & Base) {
  return (
    <textarea
      className={['ui-control', className ?? ''].filter((c) => c !== '').join(' ')}
      value={value}
      onChange={(event) => {
        onChange?.(event.target.value)
        onChangeEvent?.(event)
      }}
      {...rest}
    />
  )
}
